import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import React from 'react'
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from 'formik';
import CustomTextField from '../../../../../Components/CustomTextField/CustomTextField';
import CustomSubmitButton from '../../../../../Components/CustomSubmitButton/CustomSubmitButton';
import AxiosInstance from '../../../../../Config/AxiosInstance';
import APILIST from '../../../../../Config/ApiList';
import { toast } from 'react-toastify';
const AddCoinAdjustmentModel = (props) => {
    const { open, onClose, handleOnClose, userId, handleSubmitAddCoin } = props;
    const [isLoading, setIsLoading] = React.useState(false);
    const formik = useFormik({
        initialValues: {
            coin_adjustment: "",
            message: "",
        },
        validationSchema: Yup.object().shape({
            coin_adjustment: Yup.string().required("Coin  is required!"),
            message: Yup.string().required("Message is required!"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            if (isLoading) {
                return;
            } else {
                try {
                    const formData = new FormData();
                    formData.append("user_id", userId);
                    formData.append("type", 1);
                    formData.append("message", values.message);
                    formData.append("coin", values.coin_adjustment);
                    formData.append("admin_note", values.note);
                    formData.append("operation", 3)
                    const response = await AxiosInstance.post(APILIST.ADD_COIN_ADJUSMENT_API, formData);
                    if (response && response?.data?.s) {
                        toast.success("Coin Adjustment Added Successfully!")
                        handleOnClose();
                        resetForm();
                        setIsLoading(false);
                        handleSubmitAddCoin();
                    } else {
                        toast.error(response?.data?.m)
                        setIsLoading(false);

                    }
                } catch (error) {
                    console.log('error', error);
                    toast.error("Something went wrong!")
                    setIsLoading(false);
                }
            }

        },
    });
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "20px",
                    padding: '20px 30px',
                    height: "auto",
                    overflow: "scroll",
                    "::-webkit-scrollbar": { width: "0px", height: '0px' },
                    display: "flex",
                    flexDirection: "column",
                },
                "& .MuiDialogContent-root": {
                    overflowY: "initial",
                    flexGrow: 1,
                },
                "& .MuiBackdrop-root": {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                }
            }}
        >
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                    return false;
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography sx={{ fontSize: '20px', fontWeight: '500', color: '#101010', fontFamily: "Outfit" }}>
                            Enter Coin Adjustment
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <IconButton
                                sx={{
                                    width: '30px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#101010',
                                    borderRadius: '8px',
                                    "&:hover": { backgroundColor: '#101010', color: '#fff' }
                                }}
                                onClick={handleOnClose}
                            >
                                <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ padding: '20px 0px 0px 0px', flexGrow: 1 }}>
                    <Grid container spacing={1} justifyContent={'space-between'}>
                        <Grid item xs={12}>
                            <CustomTextField
                                label="Add Coin Adjustment"
                                type="number"
                                placeholder="Enter Coin Adjustment"
                                name="coin_adjustment"
                                value={formik.values.coin_adjustment}
                                onBlur={formik.handleBlur}
                                onKeyUp={formik.handleBlur}
                                errors={formik.touched.coin_adjustment && formik.errors.coin_adjustment}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value.trimStart() !== value) {
                                        e.target.value = value.trimStart();
                                    }
                                    if (value.length <= 5) {
                                        formik.handleChange(e);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTextField
                                label="Message"
                                type="text"
                                placeholder="Message"
                                name="message"
                                // multiline
                                // rows={3}
                                value={formik.values.message}
                                onBlur={formik.handleBlur}
                                onKeyUp={formik.handleBlur}
                                errors={formik.touched.message && formik.errors.message}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    if (value.trimStart() !== value) {
                                        e.target.value = value.trimStart();
                                    }
                                    if (value.length <= 250) {
                                        formik.handleChange(e);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    console.log('e', e);
                                    if (e.key === "Enter" && e.target.name !== 'message') {
                                        e.preventDefault();
                                        formik.handleSubmit();
                                    }
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: "16px",
                                    fontWeight: "300",
                                    color: "rgba(0, 0, 0, 0.7)",
                                    textAlign: "right",
                                    width: "100%",
                                    fontFamily: "Outfit"
                                }}
                            >
                                {formik.values?.message?.length}/250
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ paddingTop: '20px' }}>
                    <CustomSubmitButton
                        btnTitle="Done"
                        loading={isLoading}
                        type="submit"
                    />
                </Box>
            </form>
        </Dialog>
    )
}
export default AddCoinAdjustmentModel;